module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAA8BAMAAAAqDt84AAAAMFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABaPxwLAAAAD3RSTlMAgL9AzzDvnxBg3yBwUK8xx2sdAAABCElEQVQ4y+3TMUoDQRiG4REMJtg4tUWMld2uzAFSiHWsbK0srERs7DaFaOsNxBPEwgMIHkArz2BpsaxYvWFmJySb/P+mCCEQ8hTTvLDsx86aimbvyNQ4J3/Va+MaLvX8DBRfWm3h/Ws5I9iT6yOlP6H5UUTiuDdG8r44KhLHfTNWnEmjAnlcm4r3at0hEsc1E6b8TOZ7InFcY8CM08nPHInjWkiuxp9Z9DQ1Sh6XobjzdRtN7vMFKv/yXVTpgrn+1TznPuHEuSycPbh1DvhwqSl14cCYdjiTcNHLJ2/yGuZdazN4sTYJ5wA61gI3dt/nBzRFf6kXef5PtHWo6ZhFHdsaqaHO7yrzEHJ2mbRQkj8vAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/payment-methods/bank_account@2x.png
// module id = 594
// module chunks = 9